import { T_Lang } from "@/i18n/types";
import { getCurrentInstance } from "vue";

export interface ITransLabel {
    translate: string
    label: string
}

export function showLabel(value: ITransLabel, locale) {
    if (locale === 'cn') {
        return value.label
    }
    if (value.translate) {
        return value.translate
    }
    return value.label
}

export function useI18n() {
    const app = getCurrentInstance()
    return {
        $t: app.proxy.$t.bind(app.proxy),
        getEnumTrans() {
            return app.proxy.$enumTrans
        },
        getLocale: () => app.proxy.$i18n.locale as T_Lang,
        setLocale(local) {
            app.proxy.$i18n.locale = local
        },
        showLabel(value: ITransLabel) {
            return showLabel(value, app.proxy.$i18n.locale)            
        }
    }
}
